<template lang="pug">
.modal-backdrop(v-if="show", @touchmove.prevent)
  .modal-container
    .modal-close(@click="close")
    .modal-body
      img.img(src="https://m.hellobike.com/resource/helloyun/15979/Gy9f8iUCam.png")
      .title 下载哈啰App领取专享福利
      .subtitle 骑行免广告，出行更优惠
      .modal-footer(@click="close") {{ btnText }}
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      default: '去应用市场搜索哈啰App',
    },
  },
  methods: {
    close() {
      this.$emit('update:show', false);
    },
  },
};
</script>

<style lang="less" scoped>
.modal-backdrop {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}

.modal-container {
  position: relative;
  width: 3.2rem;
  border-radius: 0.12rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 0.34rem 0 0.24rem;

  .modal-close {
    position: absolute;
    top: 0.12rem;
    right: 0.12rem;
    width: 0.14rem;
    height: 0.14rem;
    background: url(https://m.hellobike.com/resource/helloyun/15979/puLhzoqsP6.png) no-repeat;
    background-size: 100%;
  }

  .modal-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    .img {
      width: 0.8rem;
      height: 0.8rem;
      margin-bottom: 0.16rem;
    }

    .title {
      font-size: 0.18rem;
      font-weight: 500;
      color: #242729;
      line-height: 0.25rem;
      margin-bottom: 0.08rem;
    }

    .subtitle {
      color: #879099;
      line-height: 0.2rem;
      font-size: 0.14rem;
      margin-bottom: 0.54rem;
    }
  }

  .modal-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.88rem;
    height: 0.48rem;
    background: #08f;
    border-radius: 0.08rem;
    font-size: 0.18rem;
    font-weight: 500;
    color: #fff;
  }
}
</style>
